module.exports = __webpack_public_path__ + "media/images/fish-0998614a4179816626c444b82ed82a0b.jpg";